import React from 'react'
import TextInput from './TextInput'

export default ({
  label,
  helpText,
  errorText,
  className,
  style,
  inputStyle,
  ...rest
}) => (
  <div className={className} style={style}>
    {label && <label className="field--label">{label}</label>}
    <TextInput style={inputStyle} {...rest} />
    {errorText && <p className="field--danger-text">{errorText}</p>}
    {helpText && <p className="field--help-text">{helpText}</p>}
  </div>
)
